import {
  ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output, ViewChildren, QueryList, ElementRef,
} from '@angular/core';
import { AttachmentAttributeModel, AttachmentMetadataModel } from '@tailormap-viewer/api';
import { AttachmentService } from '../../../services/attachment.service';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TooltipDirective } from '@tailormap-viewer/shared';

@Component({
    selector: 'tm-edit-attachments-form',
    templateUrl: './edit-attachments-form.component.html',
    styleUrls: ['./edit-attachments-form.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatTooltip,
        MatIconButton,
        TooltipDirective,
        MatIcon,
        MatButton,
    ],
})
export class EditAttachmentsFormComponent {
  public attachmentHelper = inject(AttachmentService);

  public _attachmentAttributes: AttachmentAttributeModel[] = [];

  @ViewChildren('fileInput')
  private fileInputs?: QueryList<ElementRef<HTMLInputElement>>;

  @Input({ required: true })
  public set attachmentAttributes(attachmentAttributes: AttachmentAttributeModel[] | undefined) {
    this._attachmentAttributes = attachmentAttributes || [];

  }
  public get attachmentAttributes(): AttachmentAttributeModel[] {
    return this._attachmentAttributes;
  }

  private _attachmentsByAttributeName: Map<string, Array<AttachmentMetadataModel & { url: string }>> | null = null;

  @Input()
  public set attachmentsByAttributeName(value: Map<string, Array<AttachmentMetadataModel & { url: string }>> | null) {
    this._attachmentsByAttributeName = value;

    this.newAttachmentsByAttributeName = new Map();
    this.deletedAttachments = new Set();
  }

  public get attachmentsByAttributeName(): Map<string, Array<AttachmentMetadataModel & { url: string }>> | null {
    return this._attachmentsByAttributeName;
  }

  public newAttachmentsByAttributeName: Map<string, File[]> = new Map();
  public deletedAttachments = new Set<string>();

  @Output()
  public newAttachmentsChanged = new EventEmitter<Map<string, File[]>>();

  @Output()
  public deletedAttachmentsChanged = new EventEmitter<Set<string>>();

  public onFileChange(attribute: string, $event: Event) {
    const target = $event.target as HTMLInputElement;
    const files = [
      ...this.newAttachmentsByAttributeName.get(attribute) || [],
      ...(target.files ? Array.from(target.files) : []),
    ];
    this.newAttachmentsByAttributeName.set(attribute, files);
    this.newAttachmentsChanged.emit(this.newAttachmentsByAttributeName);
    this.resetFileInputValues();
  }

  private resetFileInputValues() {
    if (this.fileInputs) {
      this.fileInputs.forEach(input => input.nativeElement.value = '');
    }
  }

  public onDeleteAttachment(attachmentId: string) {
    if (this.deletedAttachments.has(attachmentId)) {
      this.deletedAttachments.delete(attachmentId);
    } else {
      this.deletedAttachments.add(attachmentId);
    }
    this.deletedAttachmentsChanged.emit(this.deletedAttachments);
  }

  public onRemoveNewAttachment(attribute: AttachmentAttributeModel, attachment: File) {
    const files = this.newAttachmentsByAttributeName.get(attribute.attributeName)!.filter(f => f !== attachment);
    this.newAttachmentsByAttributeName.set(attribute.attributeName, files);
    this.newAttachmentsChanged.emit(this.newAttachmentsByAttributeName);
  }
}
